/** Сдвиг (px), при котором иконка реплая становится полностью видимой */
export const REVEAL_OFFSET = 40;

/**
 * Прозрачность иконки реплая при ручном свайпе: проявляется пропорционально
 * сдвигу, полностью видима при REVEAL_OFFSET.
 *
 * @param {number} offset - текущий сдвиг сообщения при свайпе (px), может быть отрицательным.
 * @returns {number} - прозрачность иконки от 0 до 1.
 */
export const getSwipeIconOpacity = (offset: number): number => Math.min(1, Math.abs(offset) / REVEAL_OFFSET);
